exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-header .form-group input {\n  float: left;\n  width: 90%;\n}\n\n.page-header .form-group i {\n  padding-left: 10px;\n  padding-top: 10px;\n  vertical-align: middle;\n  float: left;\n}\n\n.bottom-row.row {\n  margin-top: 1rem;\n}\n\n.user-preference-title {\n  font-weight: bold;\n  margin: 10px 0;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/pages/admin-reports/styles.css
// module id = 1999
// module chunks = 29